import api from '../../utils/axios';

export const waitingService = {
  checkApprovalStatus: async (identifier) => {
    const response = await api.post('/auth/check-approval-status', { identifier });
    return response.data;
  }
};

export default waitingService;
